import { useEffect, useState, useRef } from 'preact/compat';
import style from './style.css';

const FadeOutSection = (props) => {
  const [isHidden, setIsHidden] = useState(true);
  const domRef = useRef();
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setIsHidden(entry.isIntersecting));
    },
    {
      rootMargin: '170px 0px -170px 0px',
      threshold: 1,
    }
    );
    observer.observe(domRef.current);
    return () => observer.unobserve(domRef.current);
  }, []);
  return (
    <div
      className={`${style.fadeOutSection} ${isHidden ? style.isHidden  : ''}`}
      ref={domRef}
    >
      {props.children}
    </div>
  );
};

export default FadeOutSection;


// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVC/fadeOutSection/index.js